var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-art comp"},[_c('div',{ref:_vm.refV + '-art',staticStyle:{"height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }